"use client";

import { useComboInstrumentsController } from "#/hooks/useComboInstruments.controller";
import { useStrikes } from "#/hooks/useStrikes";
import { useMarketIndexPrice } from "#/store/app/indexPrices/marketIndexPrice";

import {
  findClosestATMStrikeIndex,
  showComboWarningToast,
} from "../StrategySelector.utils";

export const useStraddle = () => {
  const {
    comboPerpInstruments,
    comboOptionInstruments,
    handleAddLegs,
    buildInstrument,
  } = useComboInstrumentsController();
  const { strikes } = useStrikes();
  const { marketIndexPrice } = useMarketIndexPrice();

  // Apply long straddle: buy 1 ATM call, buy 1 ATM put (same strike, same maturity)
  // Note: Users can flip directions to create short straddle (sell both legs)
  const applyStraddle = () => {
    const atmIndex = findClosestATMStrikeIndex(strikes, marketIndexPrice);
    const atmStrike = strikes[atmIndex];

    if (atmStrike === undefined) {
      showComboWarningToast();
      return;
    }

    handleAddLegs([
      buildInstrument({
        type: "options",
        side: "buy",
        optionType: "put",
        strike: atmStrike,
        size: "1",
      }),
      buildInstrument({
        type: "options",
        side: "buy",
        optionType: "call",
        strike: atmStrike,
        size: "1",
      }),
    ]);
  };

  const isActivePatternStraddle = () => {
    if (comboPerpInstruments.length > 0 || comboOptionInstruments.length !== 2)
      return false;

    const [a, b] = comboOptionInstruments;

    if (
      a.maturity !== b.maturity ||
      a.underlying !== b.underlying ||
      a.strike !== b.strike ||
      a.side !== b.side || // Both legs must have same side (both buy OR both sell)
      a.size !== b.size ||
      !(
        (a.optionType === "call" && b.optionType === "put") ||
        (a.optionType === "put" && b.optionType === "call")
      )
    ) {
      return false;
    }

    return true;
  };

  return { applyStraddle, isActivePatternStraddle };
};
